import React from "react";
import { Col, Row } from "react-bootstrap";
import Dropzone from "react-dropzone";
import { ResidualFileUpload } from "../../../api/index";
const Months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
];
class UploadFiles extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            language: 0,
            acceptedFiles: [],
        };
        this._arrayBufferToBase64 = this._arrayBufferToBase64.bind(this);
        this.uploadFile = this.uploadFile.bind(this);
    }

    _arrayBufferToBase64(buffer) {
        var binary = "";
        var bytes = new Uint8Array(buffer);
        var len = bytes.byteLength;
        for (var i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary);
    }

    componentDidMount() {
        const heroSection = document.querySelector(".hero");
        if (heroSection) {
            window.scrollTo({
                top: heroSection.clientHeight,
                behavior: "smooth",
            });
        }
    }

    FileUpload = (file, month, CurrentYear) => {
        var base64EncodedStr = this._arrayBufferToBase64(file);
        const organization_id = this.props.organization_id;
        const data = {
            organization_id,
            base64EncodedStr,
            month,
            CurrentYear,
        };
        ResidualFileUpload(data)
            .then((response) => {
                this.props.updateResiduals();
            })
            .catch((error) => console.log(error));
    };

    uploadFile(acceptedFiles, month, CurrentYear) {
        const reader = new FileReader();
        reader.onabort = () => console.log("file reading was aborted");
        reader.onerror = () => console.log("file reading has failed");
        reader.onload = (readerEvt) => {
            const binaryStr = reader.result;
            this.FileUpload(binaryStr, month, CurrentYear);
        };
        acceptedFiles.forEach((file) => reader.readAsArrayBuffer(file));
    }

    render() {
        return (
            <Row>
                <Col className="p-lg-0 mb-4" lg={12}>
                    <div className="drag-drop-div">
                        <Dropzone
                            onDrop={(acceptedFiles) =>
                                this.uploadFile(
                                    acceptedFiles,
                                    Months[this.props.month],
                                    this.props.selectedYear,
                                )
                            }
                            accept=".xlsx"
                        >
                            {({ getRootProps, getInputProps }) => (
                                <div
                                    {...getRootProps({ className: "dropzone" })}
                                >
                                    <input {...getInputProps()} />
                                    <p className="drapanddrop-p">
                                        + Add residuals
                                    </p>
                                </div>
                            )}
                        </Dropzone>
                    </div>
                </Col>
            </Row>
        );
    }
}

export default UploadFiles;
